// Mapper: transport LC_RecalculateMyTeamOut → domain model for the "Mi equipo"
// on-demand recalculation (ASIS-5403 / REXASIS-002).

import type {
  LC_RecalculateMyTeamOut,
  MyTeamRecalculationResult,
} from '../types/myTeamRecalculate.types';


export function mapMyTeamRecalculationResult(
  out: LC_RecalculateMyTeamOut,
): MyTeamRecalculationResult {
  return {
    recalculatedEmployeesCount: out.recalculatedEmployeesCount,
    lastUpdatedAt: new Date(out.lastUpdatedAt),
  };
}
